export const DOCTYPE_STATUS = {
  IDLE: null,
  SUCCESS: '1',
  WARNING: 'warning',
  ERROR: '2',
  LOADING: 'loading',
  HANDLING: '3',
  CHECKING: '4', // đang kiểm tra
};

export const LIMIT_BONUS_ITEMS = {
  22: 30,
  23: 30,
};

export const MATCH_LIST_IMAGE = {
  22: 'data_add',
  23: 'data_loss',
};

export const PARTNER_CONFIGS = {
  gic: {
    name: 'gic',
    urlAppend: 'gic',
    apiValidatePath: '/partner/validate-preinspection-gic',
    showLicenseNumber: true,
    timingCancelAi: 30000,
    checkBlurry: true,
    showBlurryWarning: true,
    requireLocation: false,
    flash: true,
    permissionGuide: false,
  },
  liberty: {
    name: 'liberty',
    urlAppend: 'v2',
    apiValidatePath: '/partner/validate-preinspection-liberty',
    timingCancelAi: 25000,
    checkBlurry: true,
    showBlurryWarning: true,
    requireLocation: false,
    flash: true,
    permissionGuide: true,
  },
};

export const getPartnerConfig = () => {
  const path = window.location.pathname;
  return path.includes('gic') ? PARTNER_CONFIGS.gic : PARTNER_CONFIGS.liberty;
};
